import { render, staticRenderFns } from "./couponGiveLogManage.vue?vue&type=template&id=39b17d6c&scoped=true"
import script from "./couponGiveLogManage.vue?vue&type=script&lang=js"
export * from "./couponGiveLogManage.vue?vue&type=script&lang=js"
import style0 from "./couponGiveLogManage.vue?vue&type=style&index=0&id=39b17d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b17d6c",
  null
  
)

export default component.exports